import React from 'react';
import { type GDSHeadingLevel } from '@leagueplatform/genesis-core';
import { PageHeader } from '@leagueplatform/web-common-components';
import {
  type MasonryEngineNode,
  type MasonryEngineNodeRendererProps,
} from '@leagueplatform/masonry-engine';
import { formatClassNames } from '../../utils/format-masonry-class-name.util';

type MasonryPageHeaderNodeProperties = {
  heading: string;
  headingLevel?: GDSHeadingLevel;
  subheading?: string;
  backButton?: {
    show?: boolean;
    fallbackUrl?: string;
  };
};

export type MasonryPageHeaderNode = MasonryEngineNode<
  'pageHeader',
  MasonryPageHeaderNodeProperties,
  {},
  {
    contentSlot?: MasonryEngineNode<string, {}>[];
  }
>;

export type MasonryPageHeaderRendererProps =
  MasonryEngineNodeRendererProps<MasonryPageHeaderNode>;

export const MasonryPageHeaderRenderer = ({
  heading,
  headingLevel = '1',
  subheading,
  backButton,
  contentSlot,
  className,
  engineClassName,
  locatorId,
  rootElementRef,
  css,
}: MasonryPageHeaderRendererProps) => (
  <PageHeader
    className={formatClassNames(engineClassName, className)}
    css={css}
    ref={rootElementRef}
    data-testid={locatorId}
    heading={heading}
    headingLevel={headingLevel}
    subheading={subheading}
    backButton={backButton}
    contentSlot={contentSlot}
  />
);
